import {createSelector} from 'reselect';
import {currentStep} from 'src/shared/itgStep/selectors/currentStep';

export const globalVariables = createSelector(
  currentStep,
  currentStep => currentStep?.ticketData?.['Global Variables'] || {}
);
